import { render, staticRenderFns } from "./ProductShippingModal.vue?vue&type=template&id=11aacd20&"
import script from "./ProductShippingModal.vue?vue&type=script&lang=js&"
export * from "./ProductShippingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports